import React, { FC, createRef, useState, useEffect, useRef, useReducer } from 'react'
import {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    Space, Form, Button, notification, Input, InputNumber, Typography, Upload, Switch, DatePicker, Steps,Radio, RadioChangeEvent 
} from 'antd'
import { SmileOutlined, UploadOutlined, DownloadOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import type { FormInstance } from 'antd/es/form/Form'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { IAppState } from '@/store/reducers'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { autoClick, debounce, downloadFile } from '@/utils/util'
import { UploadAPI } from '@/config'
import { delFile, getFile, uploadFile } from '@/services/progress.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
// import SelectTechListPop from '@/pages/techChangeStatus/components/selectTechListPop'
import {
    addChangeStatusApply, changeStatusAudit, editChangeStatusApply, getChangeStatusById, addTopic, editTopic
} from '@/services/table.service'
import { getProjectInfoById } from '@/store/actions/tableEdit.action'
import Nav from '@/components/nav'

export const popMsg = (msg: string, success?: boolean): void => {
    const args = {
        message: msg,
        description: '',
        icon: !success ? <SmileOutlined style={{ color: '#e1931e' }} /> : <CheckCircleOutlined style={{ color: '#08993f' }} />,
        duration: 3,
    }
    notification.open(args)
}

const ShowSelectTechListPop = 'showSelectTechListPop'
const HideSelectTechListPop = 'hideSelectTechListPop'
const SetSelectTechListPop = 'setSelectTechListPop'
const SetLocationParams = 'setLocationParams'
const SetDateTime = 'setDateTime'
const SetStepItems = 'setStepItems'
const SetCurrentStep = 'setCurrentStep'
const reducer = (state: any, action: { type: string, payload?: any }) => {
    const { type, payload } = action
    switch (type) {
        case ShowSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: true
            }
        case HideSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: false,
            }
        case SetSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: false,
                selectTechObj: payload
            }
        case SetLocationParams:
            return {
                ...state,
                id: payload.id,
                mode: payload.mode
            }
        case SetDateTime:
            return {
                ...state,
                selectDate: payload
            }
        case SetStepItems:
            return {
                ...state,
                stepItems: payload
            }
        case SetCurrentStep:
            return {
                ...state,
                stepCurrent: payload
            }
        default:
            return state
    }
}
const initialState = {
    showSelectTechListPop: false,
    selectTechObj: null,
    id: null,
    mode: '',
    selectDate: [],
    stepItems: [],
    stepCurrent: -1
}

const TechChangeStatus: FC = () => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()
    const route = useSelector((state: IAppState) => state.router)
    const tableEditData = useSelector((state: IAppState) => state.tableEditData.table2EditData)
    const [stateR, dispatchR] = useReducer(reducer, initialState)
    console.log(stateR)
    const { selectTechObj, mode, id, selectDate, stepItems,stepCurrent } = stateR
    const [fileList, setFileList] = useState<(UploadFile & {
        url?: string
        fileId?: number
        status?: string
    })[]>([])
    const [fileIds, setFileIds] = useState<number[]>([])
    const [uploading, setUploading] = useState(false)
    const uploadFileLs = useRef<RcFile[]>([])
    const fileListRef = useRef<(UploadFile & {
        url?: string
        fileId?: number
        status?: string
        deleteState?: boolean
    })[]>([])
    const [fileListTask, setFileListTask] = useState<(UploadFile & {
        url?: string
        fileId?: number
        status?: string
    })[]>([])
    const [fileIdsTask, setFileIdsTask] = useState<number[]>([])
    const [uploadingTask, setUploadingTask] = useState(false)
    const uploadFileLsTask = useRef<RcFile[]>([])
    const fileListTaskRef = useRef<(UploadFile & {
        url?: string
        fileId?: number
        status?: string
        deleteState?: boolean
    })[]>([])
    const formRef = createRef<FormInstance>()
    const { Text } = Typography
    const { TextArea } = Input
    const [switchKey] = useState([2, 3])

    const onSelectRelevant = (e: RadioChangeEvent) => {
        formRef.current?.setFieldValue('approvalStatusIsFinish', e.target.value)
    }
    const handleUpload = async (files: UploadFile[], type?: string) => {
        const formData = new FormData()
        files.forEach(file => {
            formData.append('multipartFile', file as RcFile)
        })
        try {
            if (!type) {
                const res = await uploadFile(formData, 'definition')
                setFileIds([...fileIds, ...res.map(item => item.id)])
                const resLen = res.length, fileListLen = fileListRef.current.length
                const _fileList = _.cloneDeep(fileListRef.current)
                for (let i = fileListLen - 1; i > (fileListLen - resLen) - 1; i--) {
                    const resFile = res.pop()
                    _fileList[i].url = `${UploadAPI}/onlinePreview?filePath=${resFile?.fullPath}`,
                    _fileList[i].fileId = resFile?.id
                    _fileList[i].status = 'done'
                }
                setFileList(_fileList)
                uploadFileLs.current = []
            } else if (type === 'task') {
                const res = await uploadFile(formData, 'task')
                setFileIdsTask([...fileIdsTask, ...res.map(item => item.id)])
                const resLen = res.length, fileListLen = fileListTaskRef.current.length
                const _fileList = _.cloneDeep(fileListTaskRef.current)
                for (let i = fileListLen - 1; i > (fileListLen - resLen) - 1; i--) {
                    const resFile = res.pop()
                    _fileList[i].url = `${UploadAPI}/onlinePreview?filePath=${resFile?.fullPath}`,
                    _fileList[i].fileId = resFile?.id
                    _fileList[i].status = 'done'
                }
                setFileListTask(_fileList)
                uploadFileLsTask.current = []
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
        if (!type) {
            setUploading(false)
        } else if (type === 'task') {
            setUploadingTask(false)
        }
    }
    const fn = debounce(() => {
        handleUpload(uploadFileLs.current)
    }, 1000)
    // const fnTask = debounce(() => {
    //     handleUpload(uploadFileLsTask.current, 'task')
    // }, 1000)
    // 技术定义书
    const props: UploadProps = {
        fileList,
        showUploadList: {
            showDownloadIcon: true,
            showRemoveIcon: !mode,
            downloadIcon: <Text className='txt_blue hand' title={t('downloadFile')}><DownloadOutlined style={{ fontSize: 16 }} /></Text>,
            removeIcon: <Text className='txt_red hand' title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
        },
        multiple: false,
        beforeUpload: file => {
            setUploading(true)
            console.log('beforeUpload', file)
            uploadFileLs.current.push(file)
            return false
        },
        onChange: info => {
            console.log('onChange: ', info)
            fileListRef.current = info.fileList
            const addList = info.fileList.filter(file => !('fileId' in file))
            addList.forEach(item => {
                item.status = 'uploading'
            })
            setFileList([...fileList, ...addList])
            fn()
        },
        onDownload: async (file: UploadFile & {
            url?: string
            fileId?: number
            status?: string
        }) => {
            try {
                if (file.fileId) {
                    file.status = 'uploading'
                    const findIndex = fileList.findIndex(item => item.fileId === file.fileId)
                    fileList.splice(findIndex, 1, file)
                    setFileList([...fileList])
                    const res = await getFile(file.fileId)
                    downloadFile(res, file.name)
                    file.status = 'done'
                    fileList.splice(findIndex, 1, file)
                    setFileList([...fileList])
                }
            } catch (error: any) {
                const str = getErrorStr(error)
                dispatch(requestFail(str))
            }
        },
        onRemove: async (file: UploadFile & {
            url?: string
            fileId?: number
            status?: string
        }) => {
            const index = fileList.findIndex(item => file.fileId === item.fileId)
            try {
                file.status = 'removed'
                const findIndex = fileList.findIndex(item => item.fileId === file.fileId)
                fileList.splice(findIndex, 1, file)
                setFileList([...fileList])
                await delFile(file.fileId as number)
                fileList.splice(index, 1)
                setFileList([...fileList])
                setFileIds(fileIds.filter(item => item !== file.fileId))
                return Promise.resolve()
            } catch (error: any) {
                file.status = 'error'
                const str = getErrorStr(error)
                dispatch(requestFail(str))
                return Promise.reject(error)
            }
        },
        onPreview (file: any) {
            console.log('file: ', file)
            return !mode ? file : false
        }
    }
    // 任务书
    // const propsTask: UploadProps = {
    //     fileList: fileListTask,
    //     showUploadList: {
    //         showDownloadIcon: true,
    //         showRemoveIcon: !mode,
    //         downloadIcon: <Text className='txt_blue hand' title={t('downloadFile')}><DownloadOutlined style={{ fontSize: 16 }} /></Text>,
    //         removeIcon: <Text className='txt_red hand' title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
    //     },
    //     multiple: false,
    //     beforeUpload: file => {
    //         setUploadingTask(true)
    //         console.log('beforeUpload', file)
    //         uploadFileLsTask.current.push(file)
    //         return false
    //     },
    //     onChange: info => {
    //         console.log('onChange: ', info)
    //         fileListTaskRef.current = info.fileList
    //         const addList = info.fileList.filter(file => !('fileId' in file))
    //         addList.forEach(item => {
    //             item.status = 'uploading'
    //         })
    //         setFileListTask([...fileListTask, ...addList])
    //         fnTask()
    //     },
    //     onDownload: async (file: UploadFile & {
    //         url?: string
    //         fileId?: number
    //         status?: string
    //     }) => {
    //         try {
    //             if (file.fileId) {
    //                 file.status = 'uploading'
    //                 const findIndex = fileListTask.findIndex(item => item.fileId === file.fileId)
    //                 fileListTask.splice(findIndex, 1, file)
    //                 setFileListTask([...fileListTask])
    //                 const res = await getFile(file.fileId)
    //                 downloadFile(res, file.name)
    //                 file.status = 'done'
    //                 fileListTask.splice(findIndex, 1, file)
    //                 setFileList([...fileListTask])
    //             }
    //         } catch (error: any) {
    //             const str = getErrorStr(error)
    //             dispatch(requestFail(str))
    //         }
    //     },
    //     onRemove: async (file: UploadFile & {
    //         url?: string
    //         fileId?: number
    //         status?: string
    //     }) => {
    //         const index = fileListTask.findIndex(item => file.fileId === item.fileId)
    //         try {
    //             file.status = 'removed'
    //             const findIndex = fileListTask.findIndex(item => item.fileId === file.fileId)
    //             fileListTask.splice(findIndex, 1, file)
    //             setFileList([...fileListTask])
    //             await delFile(file.fileId as number)
    //             fileListTask.splice(index, 1)
    //             setFileListTask([...fileListTask])
    //             setFileIdsTask(fileIdsTask.filter(item => item !== file.fileId))
    //             return Promise.resolve()
    //         } catch (error: any) {
    //             file.status = 'error'
    //             const str = getErrorStr(error)
    //             dispatch(requestFail(str))
    //             return Promise.reject(error)
    //         }
    //     },
    //     onPreview (file: any) {
    //         console.log('file: ', file)
    //         return !mode ? file : false
    //     }
    // }
    const onHideSelectTechListPop = (values: any) => {
        dispatchR({ type: HideSelectTechListPop })
        if (values) {
            dispatchR({ type: SetSelectTechListPop, payload: {
                techProject: values
            } })
            let techName = ''
            if (values.techName) {
                if (values.techName.includes('"str":') && values.techName.includes('"obj":')) {
                    techName = JSON.parse(values.techName).str
                    techName = techName.replace(/<\/?.+?\/?>/g,'')
                } else {
                    techName = values.techName
                }
                techName = techName.replace(/\n/g, '')
                formRef.current?.setFieldValue('techName', techName)
            }
            if (Reflect.has(values, 'id')) {
                formRef.current?.setFieldValue('techProjectId', values.id)
            }
        }
    }

    // 添加课题状态申请
    const addChangeStatusApplyFn = async (data: any) => {
        try {
            console.log(data)
            if(data.fileIds && data.fileIds.length > 0){
                const res = await addChangeStatusApply(data)
                console.log('addChangeStatusApplyFn: ', res)
                history.replace('/techChangeList')
            }else{
                popMsg(t('Tech Definition Required'))
            }
            
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 审核技术定义书
    const changeStatusAuditFn = async (data: any) => {
        try {
            await changeStatusAudit(data)
            popMsg(t('Action') + (i18n.language !== 'zh' ? ' ' : '') + t('success'), true)
            history.replace('/techChangeList')
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // // 状态更新
    // const editChangeStatusApplyFn = async (data: any) => {
    //     try {
    //         await editChangeStatusApply(data)
    //         popMsg(t('Action') + (i18n.language !== 'zh' ? ' ' : '') + t('success'), true)
    //         history.replace('/techChangeList')
    //     } catch (error: any) {
    //         const str = getErrorStr(error)
    //         dispatch(requestFail(str))
    //     }
    // }
    // // 审核任务书
    // const changeStatusTaskFn = async (data: any) => {
    //     try {
    //         await changeStatusTask(data)
    //         popMsg(t('Action') + (i18n.language !== 'zh' ? ' ' : '') + t('success'), true)
    //         history.replace('/techChangeList')
    //     } catch (error: any) {
    //         const str = getErrorStr(error)
    //         dispatch(requestFail(str))
    //     }
    // }
    // 添加课题关联项目
    const addRelativeFn = async (data: any) => {
        try {
            if (!selectTechObj.techProjectTopic) {
                await addTopic(data)
            } else {
                await editTopic({
                    ...data,
                    id: selectTechObj.techProjectTopic.id
                })
            }
            if (mode === 'addrelative') {
                // 修改技术状态为 结项待评审
                if(selectTechObj.approvalStatus != 3 && selectTechObj.approvalStatus != 4 && selectTechObj.approvalStatus != 5){
                    await editChangeStatusApply({
                        ...data,
                        ...selectTechObj,
                        approvalStatus: !data.approvalStatusIsFinish ? 2 : 3, // 未勾选续期待评审，则设为2已立项，勾选则设为3结项待评审
                    })
                }else{
                    await editChangeStatusApply({
                        ...data,
                        ...selectTechObj,
                    })
                }
            }
            popMsg(t('Action') + (i18n.language !== 'zh' ? ' ' : '') + t('success'), true)
            history.replace('/techChangeList')
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 获取审核技术定义书详情
    const getAuditInfo = async () => {
        try {
            const res = await getChangeStatusById(id)
            console.log('getAuditInfo: ', res)
            
            const _fileList = res.files.map((item: any) => ({
                ...item,
                name: item?.fileName,
                url: `${UploadAPI}/onlinePreview?filePath=${item?.id}`,
                fileId: item?.id,
                status: 'done'
            }))
            setFileList(_fileList.filter((item: any) => item.fileType === 'definition'))
            setFileListTask(_fileList.filter((item: any) => item.fileType === 'task'))
            dispatchR({ type: SetSelectTechListPop, payload: res })
            dispatchR({ type: SetStepItems,
                payload: [{
                    title: t('Wait Approval'),
                    status: 'finish', // wait process finish error
                    disabled: false
                },
                {
                    title: t('Already Approval'),
                    status: mode === 'addrelative' ? 'process' : (mode === 'auditrelative' ? 'finish' : 'wait'),
                    disabled: false
                },
                {
                    title:  !res.approvalStatus ? t('jxauditWait') : res.approvalStatus === 2 || res.approvalStatus === 3 ? t('jxauditWait') : res.approvalStatus === 4 ? t('jxauditPass') : t('jxauditUnPass'),
                    status: res.approvalStatus === 3 ? 'process' : (res.approvalStatus === 4 || res.approvalStatus === 5 ? 'finish' : 'wait'),
                    disabled: mode === 'addrelative'
                }]
            })
            dispatchR({ type: SetCurrentStep, payload: mode === 'addrelative' ? 1 : (mode === 'auditrelative' ? 2 : 0) })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 结项审核
    const auditRelativeFn = async (data: any) => {
        try {
            await editChangeStatusApply(data)
            popMsg(t('Action') + (i18n.language !== 'zh' ? ' ' : '') + t('success'), true)
            history.replace('/techChangeList')
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 10 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 10 },
    }
    const onFinish = (values: any) => {
        console.log('onFinish: ', values,mode)
        switch (mode) {
        // 审核技术定义书
            case 'audit':
                changeStatusAuditFn({
                    ...values,
                    auditStatus: values.auditStatus ? 2 : 3,
                    approvalStatus:values.auditStatus === 2 ? 1 : null,
                    id,
                })
                break
                // 添加任务书
                // case 'addtask':
                //     if(fileIdsTask && fileIdsTask.length > 0){
                //         editChangeStatusApplyFn({
                //             ...values,
                //             auditStatus: selectTechObj.auditStatus,
                //             id,
                //             fileIds: fileIdsTask,
                //             taskStatus: 1
                //         })
                //     }else{
                //         popMsg(t('Tech Definition Required'))
                //     }
                //     break
                // // 审核任务书
                // case 'audittask':
                //     changeStatusTaskFn({
                //         ...values,
                //         auditStatus: selectTechObj.auditStatus,
                //         id,
                //         fileIds: selectTechObj.files.map((item: any) => item.id),
                //         taskStatus: values.taskStatus ? 2 : 3,
                //     })
                //     break
            // 添加课题关联项目
            case 'addrelative':
                addRelativeFn({
                    ...values,
                    techProjectStatusId: id,
                    startTime: values.startTime ? moment(values.startTime).format('YYYY-MM-DD') : '',
                    endTime: values.endTime ? moment(values.endTime).format('YYYY-MM-DD') : ''
                })
                break
            // 结项审核
            case 'auditrelative':
                // 修改已立项关联信息
                if (stepCurrent === 1) {
                    addRelativeFn({
                        ...selectTechObj,
                        ...values,
                        techProjectStatusId: id,
                        startTime: values.startTime ? moment(values.startTime).format('YYYY-MM-DD') : null,
                        endTime: values.endTime ? moment(values.endTime).format('YYYY-MM-DD') : ''
                    })
                    break
                }
                // 结项审核
                auditRelativeFn({
                    ...values,
                    ...selectTechObj,
                    approvalStatus: values.approvalStatusFinish ? 4 : 5,
                    approvalComments: values.approvalCommentsFinish
                })
                break
            default:
                addChangeStatusApplyFn({
                    ...values,
                    auditStatus: 1,
                })
        }
        
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        console.log('onFinishFailed: ', errorFields)
        // if (errorFields.length) {
        //     popMsg(t('FinishFailed'))
        // }
    }
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const onReset = () => {
        formRef.current?.resetFields()
        dispatchR({ type: SetLocationParams, payload: null })
    }
    
    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techChangeList',
            breadcrumbName: t('Tech Change Status')
        }
    ])

    useEffect(() => {
        const routeParams = new URLSearchParams(location.search)
        const techChangeStatusId = routeParams.get('id')
        const recordid = routeParams.get('recordid')
        // console.log('recordid: ',  recordid)
        if (recordid) {
            // 获取单据信息
            dispatch(getProjectInfoById({ projectInfoId: +recordid }))
        }
        const mode = routeParams.get('mode')
        console.log('mode: ', mode)
        dispatchR({ type: SetLocationParams, payload: {
            id: techChangeStatusId ? +techChangeStatusId : undefined,
            mode
        } })
        formRef.current?.setFieldValue('approvalStatusIsFinish', 2)
        switch (mode) {
            case 'audit':
                setRoutes([...routes, 
                    {
                        path: '/',
                        breadcrumbName: t('Approval Tech Definition')
                    }])
                break
                // case 'addtask':
                //     setRoutes([...routes, 
                //         {
                //             path: '/',
                //             breadcrumbName: t('Upload Task')
                //         }])
                //     break
                // case 'audittask':
                //     setRoutes([...routes, 
                //         {
                //             path: '/',
                //             breadcrumbName: t('Audit Task')
                //         }])
                //     break
            case 'addrelative':
                setRoutes([...routes, 
                    {
                        path: '/',
                        breadcrumbName: t('Tech Relative Project')
                    }])
                break
            case 'auditrelative':
                setRoutes([...routes, 
                    {
                        path: '/',
                        breadcrumbName: t('Finish Approval') + (i18n.language !== 'zh' ? ' ' : '') + t('audit')
                    }])
                break
            default:
                setRoutes([...routes, 
                    {
                        path: '/',
                        breadcrumbName: t('Tech_Definition_AND_TASK')
                    }])
                break
        }
    }, [])
    useEffect(() => {
        console.log('fileList: ', fileList)
        formRef.current?.setFieldValue('fileIds', fileList.map(item => item.fileId))
    }, [fileList])
    useEffect(() => {
        formRef.current?.setFieldValue('fileIdsTask', fileListTask.map(item => item.fileId))
    }, [fileListTask])
    useEffect(() => {
        onHideSelectTechListPop(tableEditData)
    }, [tableEditData])
    useEffect(() => {
        if (id) {
            // 审核技术定义书
            getAuditInfo()
        }
    }, [id])
    useEffect(() => {
        if (selectTechObj) {
            const { techProject } = selectTechObj
            if (techProject?.id) {
                // console.log({
                //     ...selectTechObj,
                //     ...selectTechObj.techProjectTopic,
                //     startTime: selectTechObj.techProjectTopic ? moment(selectTechObj.techProjectTopic.startTime, 'YYYY-MM-DD') : '',
                //     endTime: selectTechObj.techProjectTopic ? moment(selectTechObj.techProjectTopic.endTime, 'YYYY-MM-DD') : '',
                //     techProjectId: techProject.id,
                //     fileIds: fileList.map((item: any) => item.id),
                //     auditStatus: techProject.auditStatus === 2,
                //     taskStatus: techProject.taskStatus === 2
                // })
                formRef.current?.setFieldsValue({
                    ...selectTechObj,
                    ...selectTechObj.techProjectTopic,
                    startTime: selectTechObj.techProjectTopic?.startTime ? moment(selectTechObj.techProjectTopic.startTime) : '',
                    endTime: selectTechObj.techProjectTopic?.endTime ? moment(selectTechObj.techProjectTopic.endTime) : '',
                    techProjectId: techProject.id,
                    fileIds: fileList.map((item: any) => item.id),
                    auditStatus: techProject.auditStatus === 2,
                    taskStatus: techProject.taskStatus === 2
                })
            }
        }
    }, [selectTechObj])

    return (
        <Space direction='vertical' style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            {mode && mode !== 'audit' && mode !== 'addtask' && mode !== 'audittask'
            && <Steps style={{ margin: '20px 80px 30px', width: 'calc(100% - 160px)' }}
                current={stepCurrent}
                onChange={current => {
                    dispatchR({ type: SetCurrentStep, payload: current })
                }}
            >
                {stepItems.map((item: any) => (
                    <Steps.Step key={item.title} title={item.title} disabled={item.disabled}
                        status={item.status}
                    />
                ))}
            </Steps>}
            <Form {...layout} ref={formRef} name="control-ref"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="edit_table"
                // autoComplete="off"
            >
                {!mode && <Form.Item name="techName" label={<span className='label'>{t('selectTech')}</span>}>
                    {/* <Input placeholder={t('Tech Placeholder')}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            if (mode) return
                            dispatchR({ type: ShowSelectTechListPop })
                        }}
                    ></Input> */}
                    <div className='desc' dangerouslySetInnerHTML={{
                        __html: selectTechObj && selectTechObj?.techProject.techName ? JSON.parse(selectTechObj.techProject.techName).str : ''
                    }}></div>
                </Form.Item>}
                <Form.Item name='techProjectId' label={<span className='label'>{t('PTN')}</span>}
                    rules={[{ required: true, message: t('Tech Required') }]}
                >
                    {selectTechObj && <>
                        <Text>{ selectTechObj.techProject.techPtn }</Text>
                    </>}
                </Form.Item>
                {((mode !== 'addrelative' && mode !== 'auditrelative')
                    || ((mode === 'addrelative' || mode === 'auditrelative') && stepCurrent === 0)) && <>
                    <Form.Item name='fileIds' label={<span className='label'>{t('Tech_Definition_AND_TASK')}</span>}
                        rules={[{ required: true, message: t('Tech Definition Required') }]}
                    >
                        <Upload {...props} disabled={uploading} className={mode ? 'upload-dis' : ''}>
                            {!mode && <Button icon={<UploadOutlined />}
                                loading={uploading}
                            >{t('uploadFile')}</Button>}
                        </Upload>
                    </Form.Item>
                    {mode && <>
                        <Form.Item name='auditStatus' label={<span className='label'>{t('auditStatus')}</span>}
                            valuePropName="checked"
                        >
                            {mode === 'audit' ? <Switch />
                                : [t('planauditWait'), t('planauditPass'), t('planauditUnPass')][selectTechObj?.auditStatus - 1]
                            }
                        </Form.Item>
                        <Form.Item name='auditComments' label={<span className='label'>{t('auditComments')}</span>}
                            rules={[{ required: true, message: t('auditComments Required') }]}
                        >
                            {mode === 'audit' ? <TextArea /> : selectTechObj?.auditComments}
                        </Form.Item>
                    </>}
                    {/* 上传任务书 */}
                    {/* {mode && mode !== 'audit' && <Form.Item name='fileIdsTask'
                        label={<span className='label'>{ mode === 'addtask' ? t('Upload Task') : t('Task Book') }</span>}
                        rules={[{ required: true, message: t('Upload Task Required') }]}
                    >
                        <Upload {...propsTask} disabled={uploading} className={mode !== 'addtask' ? 'upload-dis' : ''}>
                            {mode === 'addtask' && <Button icon={<UploadOutlined />}
                                loading={uploadingTask}
                            >{t('uploadFile')}</Button>}
                        </Upload>
                    </Form.Item>} */}
                    {/* 任务书审核意见 */}
                    {/* {mode && mode !== 'audit' && mode !== 'addtask' && <>
                        <Form.Item name='taskStatus' label={<span className='label'>{t('Task Book') + '' + t('auditStatus')}</span>}
                            valuePropName="checked"
                        >
                            {mode === 'audittask' ? <Switch />
                                : [t('taskauditWait'), t('taskauditPass'), t('taskauditUnPass')][selectTechObj?.taskStatus - 1]
                            }
                        </Form.Item>
                        <Form.Item name='taskComments' label={<span className='label'>{t('Task Book') + '' + t('auditComments')}</span>}
                            rules={[{ required: true, message: t('auditComments Required') }]}
                        >
                            {mode === 'audittask' ? <TextArea /> : selectTechObj?.taskComments}
                        </Form.Item>
                    </>} */}
                </>}
                {/* 添加课题关联项目 */}
                {(mode === 'addrelative' || mode === 'auditrelative') && stepCurrent == 1 && <>
                    <Form.Item name='approvalNumber' label={<span className='label'>{t('approvalNumber')}</span>}>
                        <Input allowClear /> 
                        {/* {mode === 'addrelative' ? <Input allowClear /> : selectTechObj.techProjectTopic?.approvalNumber} */}
                    </Form.Item>
                    <Form.Item name='projectName' label={<span className='label'>{t('projectName')}</span>}>
                        <Input allowClear /> 
                        {/* {mode === 'addrelative' ? <Input allowClear /> : selectTechObj.techProjectTopic?.projectName} */}
                    </Form.Item>
                    <Form.Item name='projectNumber' label={<span className='label'>{t('projectNumber')}</span>}>
                        <Input allowClear /> 
                        {/* {mode === 'addrelative' ? <Input allowClear /> : selectTechObj.techProjectTopic?.projectNumber} */}
                    </Form.Item>
                    <Form.Item name='applyBu' label={<span className='label'>{t('applyBu')}</span>}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item name='landingPlatform' label={<span className='label'>{t('landingPlatform')}</span>}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item name='projectProfit' label={<span className='label'>{t('projectProfit')}</span>}>
                        <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item name='startTime' label={<span className='label'>{t('start') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}</span>}>
                        <DatePicker allowClear
                            placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('dueDate')}
                            disabledDate={current => {
                                if (selectDate.length < 1) return false
                                if (selectDate[1]) {
                                    return current.isAfter(selectDate[1].format())
                                } else {
                                    return false
                                }
                            }}
                            onChange={e => {
                                let startDate
                                if (e) {
                                    startDate = e
                                } else {
                                    startDate = moment('0000-1-1')
                                }
                                console.log([startDate, selectDate[1]])
                                dispatchR({ type: SetDateTime, payload: [startDate, selectDate[1]] })
                            }}
                        /> 
                        {/* : selectTechObj.techProjectTopic?.startTime ? moment(selectTechObj.techProjectTopic?.startTime).format('YYYY-MM-DD') : ''} */}
                    </Form.Item>
                    <Form.Item name='endTime' label={<span className='label'>{t('end') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}</span>}>
                        {/* {mode === 'addrelative' ?  */}
                        <DatePicker allowClear
                            placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('dueDate')}
                            disabledDate={current => {
                                if (selectDate.length < 1) return false
                                if (selectDate[0]) {
                                    return current.isBefore(selectDate[0].format())
                                } else {
                                    return false
                                }
                            }}
                            onChange={e => {
                                let endDate
                                if (e) {
                                    endDate = e
                                } else {
                                    endDate = moment('9999-12-31')
                                }
                                dispatchR({ type: SetDateTime, payload: [selectDate[0], endDate] })
                            }}
                        /> 
                        {/* : selectTechObj.techProjectTopic?.endTime ? moment(selectTechObj.techProjectTopic?.endTime).format('YYYY-MM-DD') : ''} */}
                    </Form.Item>
                    {mode === 'addrelative' && (selectTechObj.approvalStatus != 3 && selectTechObj.approvalStatus != 4 && selectTechObj.approvalStatus != 5) &&
                    <Form.Item name='approvalStatusIsFinish'
                        label={<span className='label'>{t('Project_Status')}</span>}
                        // valuePropName="checked"
                    >
                        {/* <Switch /> */}
                        <Radio.Group key={switchKey[0]} onChange={onSelectRelevant}>
                            <Radio value={2}>{t('Already Approval')}</Radio>
                            <Radio value={3}>{t('jxauditWait')}</Radio>
                        </Radio.Group>
                    </Form.Item>}
                </>}
                {/* 结项评审 */}
                {stepCurrent == 2 && <>
                    <Form.Item name='approvalStatusFinish' label={<span className='label'>{t('auditStatus')}</span>}
                        valuePropName="checked"
                    >
                        {mode === 'auditrelative' ? <Switch />
                            : [t('auditWait'), t('auditPass'), t('auditUnPass')][selectTechObj?.approvalStatus - 1]
                        }
                    </Form.Item>
                    <Form.Item name='approvalCommentsFinish' label={<span className='label'>{t('auditComments')}</span>}
                        rules={[{ required: true, message: t('auditComments Required') }]}
                    >
                        {mode === 'auditrelative' ? <TextArea /> : selectTechObj?.taskComments}
                    </Form.Item>
                </>}
                
                <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                    <Space size={20}>
                        { (!mode || mode === 'addtask' || (mode === 'addrelative' && stepCurrent !== 0) || (mode === 'auditrelative' && stepCurrent != 0) ) && 
                        <Button type="primary" htmlType="submit"
                            loading={uploading || uploadingTask}
                        >{ !mode ? t('submit') : mode === 'addtask' ? t('submit') :  stepCurrent === 1 ? t('submit') : t('audit')}
                        </Button>
                        }
                        { mode === 'audit' &&
                        <Button type="primary" htmlType="submit"
                            loading={uploading || uploadingTask}
                        > {t('audit')}
                        </Button>
                        }
                        {/* { mode === 'audittask' &&
                        <Button type="primary" htmlType="submit"
                            loading={uploading || uploadingTask}
                        > {t('audit')}
                        </Button>
                        } */}
                    </Space>
                </Form.Item>
            </Form>
            {/* <SelectTechListPop show={stateR.showSelectTechListPop} hide={onHideSelectTechListPop} /> */}
        </Space>
    )
}

export default TechChangeStatus